import React from 'react';

import { getErrorMessage } from '~libs/axiosWrapper';
import { useToast } from '~libs/toast';

import { Modal } from '~components';
import { Form as WizardForm } from '~components/wizard-form';

import { useCreatePaymentBatchMutation } from '~direct-debits/actions/paymentBatches';
import steps, { PaymentBatchesWizardValues } from '~direct-debits/forms/paymentBatchesWizard';

interface ComponentProps {
  isOpen: boolean;
  setIsOpen: (toggle: boolean) => void;
}

const PaymentBatchesWizard: React.FC<ComponentProps> = ({ isOpen, setIsOpen }) => {
  const [createPaymentBatch] = useCreatePaymentBatchMutation();
  const { showToast } = useToast();

  // No `collection_date` — the API leaves it null and GoCardless defaults
  // to the earliest possible collection date. A user-facing collection-date
  // picker is a v2 ask.
  const handleSubmit = async (formData: PaymentBatchesWizardValues): Promise<boolean> => {
    try {
      const result = await createPaymentBatch({
        ...(formData.description ? { description: formData.description } : {}),
        ...(formData.due_date_cutoff ? { due_date_cutoff: formData.due_date_cutoff } : {}),
      }).unwrap();
      showToast('success', `Payment batch ${result.reference} submitted to GoCardless.`);
      setIsOpen(false);
      return true;
    } catch (error) {
      showToast('danger', getErrorMessage(error));
      return false;
    }
  };

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      header="Create Payment Batch"
      includeFooter={false}
      unmountOnClose
    >
      <WizardForm<PaymentBatchesWizardValues>
        steps={steps}
        initialValues={{}}
        onComplete={handleSubmit}
        submitCaption="Create Batch & Submit to GoCardless"
      />
    </Modal>
  );
};

export default PaymentBatchesWizard;
